import { defineMessages } from 'react-intl-next';

export const i18n: {
	back: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	done: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	next: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepIndicator: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepOneTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepOneDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepTwoTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepTwoDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepThreeTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stepThreeDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	back: {
		id: 'ai-mate.getting-started-tour.back',
		defaultMessage: 'Back',
		description:
			'Button label displayed on the back button in the getting started tour spotlight within the AI conversation interface. Shown as the text on a button in the spotlight navigation. When clicked, it navigates to the previous step in the tour. The purpose is to provide users with a way to go back to review previous tour steps.',
	},
	done: {
		id: 'ai-mate.getting-started-tour.done',
		defaultMessage: 'Done',
		description:
			'Button label displayed on the done/finish button in the getting started tour spotlight within the AI conversation interface. Shown as the text on a button in the spotlight navigation on the final step. When clicked, it completes the tour and closes the spotlight. The purpose is to provide users with a clear way to finish the onboarding tour.',
	},
	next: {
		id: 'ai-mate.getting-started-tour.next',
		defaultMessage: 'Next',
		description:
			'Button label displayed on the next button in the getting started tour spotlight within the AI conversation interface. Shown as the text on a button in the spotlight navigation. When clicked, it navigates to the next step in the tour. The purpose is to provide users with a way to proceed through the onboarding tour steps.',
	},
	stepIndicator: {
		id: 'ai-mate.getting-started-tour.indicator',
		defaultMessage: '{stepNumber} of {totalSteps}',
		description:
			'Step indicator text displayed in the getting started tour spotlight within the AI conversation interface, showing the current step number and total number of steps. Shown as text in a step indicator component. The stepNumber placeholder will be substituted with the current step number (e.g., "1", "2"). The totalSteps placeholder will be substituted with the total number of steps (e.g., "3"). The purpose is to help users understand their progress through the onboarding tour.',
	},
	stepOneTitle: {
		id: 'ai-mate.getting-started-tour.step-one.title',
		defaultMessage: 'Add work from anywhere',
		description:
			'Title text displayed in the first step of the getting started tour spotlight within the AI conversation interface. Shown as the heading in the spotlight step. The purpose is to introduce users to the feature that allows them to add work items, files, or content from various sources to enhance their AI prompts.',
	},
	stepOneDescription: {
		id: 'ai-mate.getting-started-tour.step-one.description',
		defaultMessage:
			'Choose a template, upload a file, link a page, and more to power your creation.',
		description:
			'Description text displayed in the first step of the getting started tour spotlight within the AI conversation interface. Shown as the body text below the title in the spotlight step. The purpose is to explain the various ways users can enhance their AI prompts by adding templates, files, page links, and other content sources to provide context for the AI assistant.',
	},
	stepTwoTitle: {
		id: 'ai-mate.getting-started-tour.step-two.title',
		defaultMessage: 'Get unstuck on your prompt',
		description:
			'Title text displayed in the second step of the getting started tour spotlight within the AI conversation interface. Shown as the heading in the spotlight step. The purpose is to introduce users to features that help them when they are unsure what to ask or need inspiration for their prompts.',
	},
	stepTwoDescription: {
		id: 'ai-mate.getting-started-tour.step-two.description',
		defaultMessage: 'Try an example or use them to jump-start your draft.',
		description:
			'Description text displayed in the second step of the getting started tour spotlight within the AI conversation interface. Shown as the body text below the title in the spotlight step. The purpose is to explain that users can use example prompts or templates to help them get started when they are unsure what to ask the AI assistant.',
	},
	stepThreeTitle: {
		id: 'ai-mate.getting-started-tour.step-three.title',
		defaultMessage: 'Talk to Rovo instead of typing',
		description:
			'Title text displayed in the third step of the getting started tour spotlight within the AI conversation interface. Shown as the heading in the spotlight step. The purpose is to introduce users to the voice input feature, allowing them to interact with the AI assistant using speech instead of typing.',
	},
	stepThreeDescription: {
		id: 'ai-mate.getting-started-tour.step-three.description',
		defaultMessage: 'Use your voice to get started.',
		description:
			'Description text displayed in the third step of the getting started tour spotlight within the AI conversation interface. Shown as the body text below the title in the spotlight step. The purpose is to explain that users can use voice input to interact with the AI assistant, making it easier to get started without typing.',
	},
});
